import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from './date-picker.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';

// here is the default text string
export const DefaultIntl = {
  /** A label for the cancel button */
  cancelBtnLabel: '✕',

  /** A label for the set button */
  setBtnLabel: '✓'
};

@NgModule({
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormsModule
  ],
  providers: [{ provide: OwlDateTimeIntl, useValue: DefaultIntl }]
})
export class DatePickerModule {}



// WEBPACK FOOTER //
// ./src/app/modules/date-picker/date-picker.module.ts